exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div_ForgotPasswordScreen{\n    padding: 2em;\n}", ""]);

// exports
